import { methodGet, methodDelete, methodPost, methodPut, methodPatch } from './methods';
import { API_INFO } from '../constants';

export async function getProducts(payload) {
  const url = API_INFO + 'products/products/';
  return methodGet(url, payload);
}

export async function getProductsByMateriaIbic(bookIbic) {
  const url = API_INFO + 'products/products/by_materia_ibic';
  return methodGet(url, { book_ibic: bookIbic });
}

export const getProduct = async (id) => {
  return methodGet(API_INFO + 'products/products/' + id + '/');
};

export const getDetailProduct = async (id) => {
  const url = API_INFO + `products/products/${id}/`;
  return methodGet(url);
};

export const createProduct = (payload) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  const url = API_INFO + 'products/products/';
  return methodPost(url, payload, config);
};

export const editProduct = (id, payload) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  const url = API_INFO + `products/products/${id}/`;
  return methodPatch(url, payload, config);
};

export const deleteProduct = (id) => {
  const url = API_INFO + `products/products/${id}/`;
  return methodDelete(url);
};

export async function getRelatedProduct(id, query) {
  const url = API_INFO + `products/products/${id}/related_products/`;
  return methodGet(url, query);
}

export async function getPublishedCountries(query) {
  const url = API_INFO + `products/products/get_published_countries/`;
  return methodGet(url, query);
}

export async function getLanguageProducts(query) {
  const url = API_INFO + `products/products/get_lan_products/`;
  return methodGet(url, query);
}

export async function searchProduct(query) {
  const url = API_INFO + `products/products/search_products/`;
  return methodGet(url, query);
}

export async function searchFilterProduct(query) {
  const url = API_INFO + `products/products/`;
  return methodGet(url, query);
}

export async function listAudiencia() {
  const url = API_INFO + 'products/products/get_clasification_products/';
  return methodGet(url, {});
}

export const slidersClient = (query) => {
  const url = (API_INFO + 'products/slider-elements/');
  return methodGet(url, query);
};

export const getRangeDatePublished = () => {
  const url = API_INFO + 'products/products/get_range_fecha_public/';
  return methodGet(url, {});
};

export async function removeItemFav(url) {
  const apiUrl = API_INFO + `products/products/${url}/remove_saved_user/`;
  return methodDelete(apiUrl, url);
}

export async function getAllAuthors(payload) {
  const url = API_INFO + `products/authors/`;
  return methodGet(url, payload);
}
export async function getAuthor(urlParam) {
  const url = API_INFO + `products/authors/${urlParam}/`;
  return methodGet(url);
}
export async function deleteAuthor(id) {
  const url = API_INFO + `products/authors/${id}/`;
  return methodDelete(url);
}
export async function editAuthor(payload, id) {
  const url = API_INFO + `products/authors/${id}/`;
  return methodPut(url, payload);
}
export async function createAuthor(payload) {
  const url = API_INFO + `products/authors/`;
  return methodPost(url, payload);
}

export async function getProductsByAuthor(slug, query) {
  const url = API_INFO + `products/authors/${slug}/get-products`;
  return methodGet(url, query);
}

export async function getAllEditorials(query) {
  return methodGet(API_INFO + `products/editorials/`, query);
}
export async function deleteEditorial(id) {
  const url = API_INFO + `products/editorials/${id}/`;
  return methodDelete(url);
}
export async function editEditorial(id, payload) {
  const url = API_INFO + `products/editorials/${id}/`;
  return methodPut(url, payload);
}
export async function createEditorial(payload) {
  const url = API_INFO + `products/editorials/`;
  return methodPost(url, payload);
}
export async function getDetailEditorial(id) {
  const url = API_INFO + `products/editorials/${id}/`;
  return methodGet(url, {});
}

export async function getProductsByEditorial(slug, query) {
  const url = API_INFO + `products/editorials/${slug}/get-products`;
  return methodGet(url, query);
}

export async function getStockProviders(id) {
  const url = API_INFO + `products/products/${id}/get_stock_cegal`;
  return methodGet(url, {});
}

export const postUserReview = async (payload) => {
  const url = API_INFO + 'products/products/comentary-product/';
  return methodPost(url, payload);
};

export async function getAllDiscountCoupons(query) {
  const url = API_INFO + `products/discount-coupons/`;
  return methodGet(url, query);
}
export async function getDiscountCoupon(id) {
  const url = API_INFO + `products/discount-coupons/${id}/`;
  return methodGet(url);
}
export async function createDiscountCoupon(payload) {
  const url = API_INFO + `products/discount-coupons/`;
  return methodPost(url, payload);
}
export async function editDiscountCoupon(id) {
  const url = API_INFO + `products/discount-coupons/${id}/`;
  return methodPut(url);
}
export async function deleteDiscountCoupon(id) {
  const url = API_INFO + `products/discount-coupons/${id}/`;
  return methodDelete(url);
}
export async function getValidateDiscount(query) {
  const url = API_INFO + `products/discount-coupons/validate-discount/`;
  return methodGet(url, query);
}

export async function getRestockNotificationSubscription(id) {
  const url = API_INFO + `products/notify-availability/${id}/`;
  return methodGet(url);
}
export async function deleteEmailAvailabilityNotificationSubscription(id) {
  const url = API_INFO + `products/notify-availability/${id}/`;
  return methodDelete(url);
}
export async function updateEmailAvailabilityNotificationSubscription(id) {
  const url = API_INFO + `products/notify-availability/${id}/`;
  return methodPut(url);
}
export async function postNotifyAvailability(payload) {
  const url = API_INFO + 'products/notify-availability/';
  return methodPost(url, payload);
}

export async function getAuthors(query) {
  let url = API_INFO + `products/authors/`;
  return methodGet(url, query);
}

export async function getKeywords() {
  const url = API_INFO + `products/palabras-claves/`;
  return methodGet(url, {});
}

export async function postKeyword(payload) {
  const url = API_INFO + 'products/palabras-claves/';
  return methodPost(url, payload);
}

export async function deleteKeyword(id) {
  const url = API_INFO + `products/palabras-claves/${id}/`;
  return methodDelete(url, {});
}

export const editKeyword = async (id, payload) => {
  const url = API_INFO + `products/palabras-claves/${id}/`;
  return methodPut(url, payload);
};

export const getProductsAuthor = async (id, payload) => {
  const url = API_INFO + `products/authors/${id}/get-products/`;
  return methodGet(url, payload);
};

export const getProductDetailByType = async (id, type) => {
  let url = '';

  if (type === 'book') {
    url = API_INFO + `books/books/${id}/`;
  } else if (type === 'merchandising') {
    url = API_INFO + `products/merchandising/${id}/`;
  } else {
    throw new Error('Tipo de producto no válido');
  }

  return methodGet(url);
};

export async function getProductsFast(payload) {
  const url = API_INFO + 'products/products/fast_search/';
  return methodGet(url, payload);
}

export async function getProductsCountsTotalStock() {
  const url = API_INFO + 'products/products/counts-total-stock/';
  return methodGet(url, {});
}